import { z } from 'zod';
import { requiredString } from '../helpers';
export const Parse_Attachment_2_ConfigValidator = z.object({
    fileName: requiredString('File name is required'),
    outputSchema: z.record(z.string(), z.any()),
    proMode: z.boolean().optional()
});
//# sourceMappingURL=parse-attachment-2.js.map